export default function Marquee({ items = [] }) {
  if (!items?.length) return null;

  const renderRun = (keyPrefix) =>
    items.map((item, idx) => (
      <span key={`${keyPrefix}-${idx}`}>
        <span>{item}</span>
        <span className="dot" aria-hidden>·</span>
      </span>
    ));

  return (
    <section className="fs-marquee" data-testid="marquee">
      <div className="fs-marquee-track">
        {renderRun("a")}
        {renderRun("b")}
      </div>
    </section>
  );
}
